<span [id]="identifier + '-error'" class="govuk-error-message">
  <span class="govuk-!-display-block" *ngFor="let error of errors | keyvalue">
    <span class="govuk-visually-hidden">Error:</span> {{ error.value }}
  </span>
</span>
